<template>
  <div v-if="!isLogin && !hasMaintenance">
    <TheButton
      v-if="isDesktop"
      :id="isCN ? 'tracking_login' : undefined"
      :title="$t('header.login')"
      class="w-[110px]"
      @click="handleLogin"
    >
      <span
        v-if="isUserVerifying"
        class="flex h-6 w-full items-center justify-center"
      >
        <IconLoader class="h-4 w-4 text-white" />
      </span>
      <span v-else class="text-sm font-bold leading-6">
        {{ $t('header.login') }}
      </span>
    </TheButton>
    <button
      v-else
      :id="isCN ? 'tracking_login' : undefined"
      class="flex h-8 w-8 items-center justify-center"
      @click="handleLogin"
    >
      <IconLoader v-if="isUserVerifying" class="h-5 w-5 text-blue-400" />
      <IconUser v-else class="h-5 w-5 text-blue-400" />
    </button>
  </div>
</template>

<script setup lang="ts">
  const { isCN } = useLanguage();
  const { isDesktop } = useScreen();
  const profileStore = useProfileStore();
  const { isLogin, isUserVerifying, profile } = storeToRefs(profileStore);

  const hasMaintenance = computed((): boolean => {
    /**
     * * NOTE: 目前是否有開啟維護公告
     * * 如果有開啟維護公告，則不顯示登入按鈕（未登入）與會員按鈕（已登入）
     */
    return !!profile.value.maintenanceTimePeriod;
  });

  const handleLogin = (): void => {
    if (import.meta.client && !isUserVerifying.value) {
      const callbackUrl = window.location.href;
      profileStore.HANDLE_LOGIN(callbackUrl);
    }
  };
</script>
